export const LogoIcon = () => <span className="studio-logo">in</span>;
